import * as React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { breakpoints, sizes, theme } from '../../theme';
import { BodyRegular, FlexColAlignCenter, FlexColLg, Headline2 } from '../../components/Elements';
import strings from 'strings/strings.json';
import { LearnerCourseContext } from 'contextProviders/LearnerCourseContext';
import { useContext } from 'react';
import LearnerCourseView from 'components/learnerCourse/LearnerCourseView';
import LearnerImmersiveView from './module/LearnerImmersiveView';
import Button from 'components/buttons/Button';

export default function LearnerCoursePage(): JSX.Element {
    const learnerCourse = useContext(LearnerCourseContext).learnerCourse;
    const { step, setImmersiveMode } = useContext(LearnerCourseContext);
    const navigate = useNavigate();

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, [step]);

    React.useEffect(() => {
        if (step.stepType === 'Module' || step.stepType === 'Activity') {
            setImmersiveMode(true);
        } else {
            setImmersiveMode(false);
        }
    }, [step.stepType, setImmersiveMode]);

    if (!learnerCourse) return <></>;

    if (learnerCourse.cancelledDate) {
        return (
            <CancelledCourseBackground>
                <CancelledCourseBody>
                    <Headline2>{strings.cancelledCourseComponent.headlineText}</Headline2>
                    <BodyRegular>{strings.cancelledCourseComponent.bodyText}</BodyRegular>
                    <Button
                        type="submit"
                        title={strings.cancelledCourseComponent.backToCoursesButtonText}
                        aria={strings.cancelledCourseComponent.backToCoursesButtonAria}
                        onClick={() => navigate('/')}
                    />
                </CancelledCourseBody>
            </CancelledCourseBackground>
        );
    }

    switch (step.stepType) {
        case 'Activity':
            return (
                <BaseContainer>
                    <LearnerImmersiveView key={`activity-${step.id}`} />
                </BaseContainer>
            );
        case 'Module':
            return (
                <BaseContainer>
                    <LearnerImmersiveView key={`module-${step.id}`} />
                </BaseContainer>
            );
        case 'Course':
        default:
            return (
                <BaseContainer>
                    <LearnerCourseView />
                </BaseContainer>
            );
    }
}

const BaseContainer = styled(FlexColAlignCenter)`
    min-height: calc(100vh - ${sizes.headerHeight} - ${sizes.footerHeight});
`;

const CancelledCourseBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${theme.contentBackgroundColourTrainer};
`;

const CancelledCourseBody = styled(FlexColLg)`
    align-items: center;
    margin: 15rem ${sizes.edgePadding} 5rem ${sizes.edgePadding};
    @media (max-width: ${breakpoints.sm}) {
        margin-top: 10rem;
        margin-bottom: 5rem;
    }
`;
